<template>
  <single-panel-page>
    <div v-if="!registered">
      <div class="form" :class="{ 'loader-cover': inProgress }">
        <input
          v-model="email"
          class="form-control"
          type="text"
          placeholder="E-mail"
          autofocus
          :class="{ 'has-errors': errors.email.length }"
          @keyup.enter="submit()"
        />
        <p
          v-for="error in errors.email"
          :key="error"
          class="text-danger text-sm"
        >
          {{ error }}
        </p>
        <input
          v-model="password"
          class="form-control"
          type="password"
          placeholder="Password"
          autofocus
          @keyup.enter="submit()"
          @focus="isPasswordFieldFocused = true"
          @blur="isPasswordFieldFocused = false"
        />
        <password :value="password" :show-errors="isPasswordFieldFocused" />

        <div class="row hidden">
          <div class="col-sm-12 col-md-6">
            <div class="radio">
              <label>
                <input type="radio" name="role" value="startup" />
                <span>Startup</span>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="radio">
              <label>
                <input type="radio" name="role" value="investor" />
                <span>Investor</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-right">
          <button
            class="btn btn-block btn-primary text-uppercase"
            :disabled="inProgress"
            @click="submit()"
          >
            <span>Register</span>
          </button>
        </div>
      </div>
    </div>

    <div v-show="registered" class="row animated fadeIn">
      <div class="col-sm-12">
        <p class="text-info text-sm">
          Thank you for signing up. We've sent you a message with an activation
          link. Please check your mailbox.
        </p>
      </div>
    </div>

    <div slot="bottom">
      <span class="splash-box-footer">
        <span class="hidden-xs">Already have an account? &nbsp;&nbsp;</span>
        <router-link class="text-yellow" :to="{ name: 'login' }"
          >Login here</router-link
        >
      </span>
    </div>
  </single-panel-page>
</template>

<script>
import Promise from 'bluebird'
import Auth from 'services/Auth'

export default {
  data: function () {
    return {
      role: 'startup',
      email: '',
      password: '',
      inProgress: false,
      registered: false,
      errors: { email: [] },
      isPasswordFieldFocused: false,
    }
  },
  computed: {
    hasErrors: function () {
      return this.errors.email.length > 0
    },
  },
  methods: {
    submit() {
      const self = this
      self.clearErrors()
      self.inProgress = true
      let request = Auth.signup(self.email, self.password)
      request = Promise.delay(1000).return(request)
      request
        .then((response) => {
          self.inProgress = false
          self.registered = true
        })
        .catch((error) => {
          console.log(' => registration failed! response:', error.response)
          Object.assign(self.errors, error.response.data)
          self.inProgress = false
        })
    },
    clearErrors() {
      this.errors = { email: [], password: [] }
    },
  },
}
</script>
